import ImageVideoCarousel from './ImageVideoCarousel';

export default ImageVideoCarousel;
